/* @flow */
import { List, Map, Record } from 'immutable';
import { isMapLike, isListLike } from 'trustar/utils';

export const NotificationPreferences = Record({
  activity: Map({
    global: Map({ emailEnabled: true }),
    newReport: Map({ emailEnabled: true }),
    watchedKeyword: Map({ emailEnabled: true }),
  }),
  activitySummary: Map({
    dailyEnabled: true,
    weeklyEnabled: true,
  })
});

export type NotificationPreferencesType = typeof NotificationPreferences;

export const toNotificationPreferences = (k: string, v: any) => {
  if (k === '') {
    return NotificationPreferences(v);
  } else if (isMapLike(v)) {
    return Map(v);
  } else if (isListLike(v)) {
    return List(v);
  } else {
    return v;
  }
};

export const WatchedKeyword = Record({
  guid: '',
  keyword: '',
});
export const WatchedKeywords: WatchedKeywordsType = List();

export type WatchedKeywordType = typeof WatchedKeyword;
export type WatchedKeywordsType = List<WatchedKeywordType>;

export const toWatchedKeywords = (k: string, v: any) => {
  if (k === '') {
    return List(v);
  } else if (isMapLike(v)) {
    return Map(v);
  } else if (isListLike(v)) {
    return List(v);
  } else {
    return v;
  }
};


// WEBPACK FOOTER //
// ./src/app/modules/notificationPreferences/types.js